import React from "react"
import { Link } from "react-router-dom"
import { AdvancedImage } from "@cloudinary/react"
import { useTheme } from "@mui/material/styles"
import { Box, Grid } from "@mui/material"
import { caLogoImg } from "../../utils/cloudinaryImageUtils"
import SocialMediaIcons from "./SocialMediaIcons"
import { SCHOOL_LICENSE_NUMBERS } from "../../config"

const Footer = () => {
  const theme = useTheme()

  return (
    <footer className="footer">
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={3}>
          <AdvancedImage cldImg={caLogoImg} alt="Coastline Academy Logo Mark" />
          <ul style={{ marginTop: 20, marginBottom: 20 }}>
            {SCHOOL_LICENSE_NUMBERS.map((license) => (
              <li key={license.label}>
                {license.href ? (
                  <a
                    href={license.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {license.label}
                  </a>
                ) : (
                  <span>{license.label}</span>
                )}
              </li>
            ))}
          </ul>
          &copy; Coastline Academy
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <h3 style={{ marginTop: 0, color: theme.palette.secondary.light }}>
            Who We Are
          </h3>
          <ul>
            <li>
              <Link to="/article/about-coastline-academy">About Us</Link>
            </li>
            <li>
              <Link to="/careers">Careers</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <Link to="/article/terms-of-service">Terms of Service</Link>
            </li>
            <li>
              <Link to="/article/privacy-notice">Privacy</Link>
            </li>
            <li>
              <Link to="/affiliate-signup">Affiliates</Link>
            </li>
          </ul>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <h3 style={{ marginTop: 0, color: theme.palette.secondary.light }}>
            What We Do
          </h3>
          <ul>
            <li>
              <Link to="/courses">Drivers Ed</Link>
            </li>
            <li>
              <Link to="/book">Driving Lessons</Link>
            </li>
            <li>
              <ul className="sub-tree">
                <li>
                  └{" "}
                  <Link to="/coastline-academy-driving-school-reviews">
                    Reviews
                  </Link>
                </li>
                <li>
                  └ <Link to="/locations">Locations</Link>
                </li>
                <li>
                  └ <Link to="/pricing">Pricing</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/articles">Articles</Link>
            </li>
            <li>
              <Link to="/how-to-get-drivers-license">How to Get a License</Link>
            </li>
            <li>
              <Link to="/article/selling-your-driving-school-to-coastline">
                Sell Your School
              </Link>
            </li>
          </ul>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <h3 style={{ marginTop: 0, color: theme.palette.secondary.light }}>
            Why We Exist
          </h3>
          <p>
            We&apos;re on a mission to eradicate car crashes. We do this by
            helping people become safe, confident drivers for life.
          </p>
          <h3 style={{ color: theme.palette.secondary.light }}>
            States Where We Operate
          </h3>
          <ul>
            <li>
              <Link to="/state/ca">California</Link>
            </li>
            <li>
              <Link to="/state/co">Colorado</Link>
            </li>
            <li>
              <Link to="/state/il">Illinois</Link>
            </li>
            <li>
              <Link to="/state/in">Indiana</Link>
            </li>
            <li>
              <Link to="/state/mo">Missouri</Link>
            </li>
            <li>
              <Link to="/state/pa">Pennsylvania</Link>
            </li>
            <li>
              <Link to="/state/nv">Nevada</Link>
            </li>
            <li>
              <Link to="/state/tx">Texas</Link>
            </li>
          </ul>
        </Grid>
      </Grid>
      <SocialMediaIcons />
      <Box display="flex" justifyContent="center">
        <span>v{window.APP_VERSION}</span>
      </Box>
    </footer>
  )
}

export default Footer
